import { useSessionInfo } from '~/shared/contexts';

export function useUser() {
  const { sessionInfo } = useSessionInfo();

  const isProxying = Boolean(sessionInfo?.proxiedAs);
  const user = isProxying ? sessionInfo?.proxiedAs : sessionInfo;

  return {
    name: user?.name,
    zone: user?.zone,
    globalId: user?.globalId,
    employeeId: user?.employeeId,
    managedZones: user?.managedZones,
    roles: user?.roles,
    language: user?.language,
    persona: user?.persona,
    isProxying,
    band: user?.band
  };
}

export type User = ReturnType<typeof useUser>;
